import { ParsedMediaImage, Styles } from "../../drupal_models/types"


export const placeholderStyleUrls: Styles = {
  "1080x900": "https://placehold.co/1080x900",
  "1173w": "https://placehold.co/1173",
  "1200x900": "https://placehold.co/1200x900",
  "1248x848": "https://placehold.co/1248x848",
  "1280w": "https://placehold.co/1280",
  "1280x720": "https://placehold.co/1280x720",
  "1564w": "https://placehold.co/1564",
  "1600w": "https://placehold.co/1600",
  "1880x1880": "https://placehold.co/1880x1880",
  "195w": "https://placehold.co/195",
  "195x195": "https://placehold.co/195x195",
  "200x140": "https://placehold.co/200x140",
  "2496x1696": "https://placehold.co/2496x1696",
  "300x210": "https://placehold.co/300x210",
  "300x300": "https://placehold.co/300x300",
  "360x300": "https://placehold.co/360x300",
  "380h": "https://placehold.co/380",
  "390h": "https://placehold.co/390",
  "390w": "https://placehold.co/390",
  "390x390": "https://placehold.co/390x390",
  "391w": "https://placehold.co/391",
  "400w": "https://placehold.co/400",
  "400x280": "https://placehold.co/400x280",
  "420x320": "https://placehold.co/420x320",
  "420x320_cropped": "https://placehold.co/420x320",
  "440x440": "https://placehold.co/440x440",
  "448x448": "https://placehold.co/448x448",
  "470x470": "https://placehold.co/470x470",
  "478x478": "https://placehold.co/478x478",
  "600x420": "https://placehold.co/600x420",
  "600x600": "https://placehold.co/600x600",
  "624x424": "https://placehold.co/624x424",
  "720x600": "https://placehold.co/720x600",
  "782w": "https://placehold.co/782",
  "790w": "https://placehold.co/790",
  "790x445": "https://placehold.co/790x445",
  "800w": "https://placehold.co/800",
  "800x560": "https://placehold.co/800x560",
  "840x640": "https://placehold.co/840x640",
  "840x640_cropped": "https://placehold.co/840x640",
  "880x880": "https://placehold.co/880x880",
  "896x896": "https://placehold.co/896x896",
  "940x940": "https://placehold.co/940x940",
  "956x956": "https://placehold.co/956x956",
  crop_thumbnail: "https://placehold.co/50",
  large: "https://placehold.co/200",
  medium: "https://placehold.co/100",
  thumbnail: "https://placehold.co/50"
}

export interface NavigationItem {
  readonly key: string
  readonly title: string
  readonly external: boolean
  readonly absolute: string
  readonly relative: string | null
  readonly weight: string
}

export interface MediaUrls {
  readonly mid: number;
  readonly uuid: string;
  readonly langcode: string;
  readonly status: boolean;
  readonly name: string;
  readonly thumbnail: {
    alt: string;
    url: string;
    width: number;
    height: number;
    style_urls: Styles;
  };
}

export interface Activity {
  readonly id: string
  readonly product_db_id: string
  readonly title: string
  readonly url: string
  readonly description: string
  readonly image_url: string
  readonly image_alt: string
  readonly image_id: string
  image: ParsedMediaImage
}

export interface Location {
  readonly id: string
  readonly product_db_id: string
  readonly title: string
  readonly url: string
}

export interface Report {
  id: string
  url: string
  title: string
  imageUrl: string
  imageUrlLarge?: string
  imageAlt: string
  created: string
  shortDescription: string
  datetime: string
  location: string
}

export interface Teaser {
  id: string
  title: string
  url: string
  imageUrl: string
  imageUrlLarge?: string
  imageAlt: string
  description: string
}

export interface Room {
  title: string
  description: string
  ovatic_id: number
  url: string
  image_url: string
  image_url_large?: string
  image_alt: string
}

export interface Category {
  name: string
  slug: string
}